import React from "react";
import { Download, ExternalLink, FileText, RefreshCw } from "lucide-react";
import Button from "../forms/Button";
import { SectionCard } from "./shared";
import { fmtDate } from "./sprintDocuments";

/**
 * The card for a generated sprint PDF (plan, timeline): the saved file with its
 * "Up to date / Outdated" state, Download, and (admins) Regenerate / Retry.
 */
const SprintDocumentCard = ({ title, doc, busy, genError, admin, onDownload, onRegenerate, emptyText }) => (
  <SectionCard
    title={title}
    actions={
      <div className="flex flex-wrap gap-2">
        <Button variant="secondary" size="sm" onClick={onDownload}>
          <Download className="w-4 h-4" /> Download PDF
        </Button>
        {admin && (
          <Button size="sm" onClick={onRegenerate} disabled={busy}>
            <RefreshCw className={`w-4 h-4 ${busy ? "animate-spin" : ""}`} />
            {busy ? "Saving…" : genError ? "Retry" : "Regenerate now"}
          </Button>
        )}
      </div>
    }
  >
    {genError && (
      <div role="alert" className="mb-3 text-sm p-3 rounded-xl border border-danger/30 bg-danger-soft text-danger">
        The PDF could not be saved automatically: {genError}
        {admin && " Use Retry."}
      </div>
    )}
    {doc ? (
      <div className="flex flex-wrap items-center gap-2 text-sm">
        <FileText className="w-4 h-4 text-faint" />
        <a href={doc.url} target="_blank" rel="noopener noreferrer" className="text-primary-accent hover:underline inline-flex items-center gap-1">
          {doc.name} <ExternalLink className="w-3 h-3" />
        </a>
        <span className="text-xs text-faint">saved {fmtDate(doc.generatedAt)}</span>
        {doc.stale ? (
          <span className="pill pill-warn">
            {busy ? "Updating…" : admin ? "Outdated — updating automatically" : "Outdated — tasks changed since this PDF"}
          </span>
        ) : (
          <span className="pill pill-ok">Up to date</span>
        )}
      </div>
    ) : (
      <p className="text-sm italic text-faint">{busy ? "Generating the PDF…" : `${emptyText}${admin ? " It is generated automatically." : ""}`}</p>
    )}
  </SectionCard>
);

export default SprintDocumentCard;
